import { Box, Button, Flex, Text } from "@mantine/core";
import { IconTrendingUp } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const GetReferralLink = () => {
  const navigate = useNavigate();
  return (
    <Box bg={"#F3F3F3"}>
      <Flex justify={"flex-end"} p={"sm"}>
        <Button onClick={() => navigate("/track-referral")}>
          <Text px={"sm"}>Track referral</Text>
          <IconTrendingUp size={"18"} />
        </Button>
      </Flex>
      <embed
        style={{ width: "100%", height: "calc(100vh - 110px)" }}
        src="https://embed.referral-factory.com/UeFeb8"
      />
    </Box>
  );
};
export default GetReferralLink;
